import { getImagenURL } from "../../../Utiles/Formatos";

export function ImagenSola({ data: { props: { backgroundColor, fluid, img } } }: any) {
    return <div style={{ padding: fluid ? '0 0 0 0' : '60px 0', background: backgroundColor }}>
        {fluid ? <img src={getImagenURL(img)} width='100%' alt='panel a' /> : <div className="container">
            <img src={getImagenURL(img)} width='100%' alt='panel a' />
        </div>}
    </div>
}
